import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CreateUserModalPage } from './create-user-modal';

@NgModule({
  declarations: [
    CreateUserModalPage,
  ],
  imports: [
    IonicPageModule.forChild(CreateUserModalPage),
  ],
})
export class CreateUserModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/create-user-modal/create-user-modal.module.ts